import { Element4, Profile2User, UserSquare, Calendar, MoneyRecive, Setting2, DocumentText, AddCircle, Eye, ClipboardText, TickCircle, Timer, CalendarEdit, Receipt, DollarCircle, CardReceive, DocumentCopy, Wallet, MoneyChange } from 'iconsax-react';

export const sidebarConfig = [
  {
    section: "Navigation",
    items: [
      {
        label: "Dashboard",
        icon: Element4,
        href: "/dashboard"
      }
    ]
  },
  {
    section: "Patient Management",
    items: [
      {
        label: "Patients",
        icon: UserSquare,
        children: [
          { label: "All Patients", href: "/patients/list", icon: Eye },
          { label: "Register Patient", href: "/patients/register", icon: AddCircle }
        ]
      }
    ]
  },
  {
    section: "Caregiver Management",
    items: [
      {
        label: "Caregivers",
        icon: Profile2User,
        children: [
          { label: "All Caregivers", href: "/caregivers/list", icon: Eye },
          { label: "Register Caregiver", href: "/caregivers/register", icon: AddCircle }
        ]
      }
    ]
  },
  {
    section: "Shift Management",
    items: [
      {
        label: "Shifts",
        icon: Calendar,
        children: [
          { label: "Shift Calendar", href: "/shifts/calendar", icon: CalendarEdit },
          { label: "Create Shift", href: "/shifts/create", icon: AddCircle },
          { label: "Shift Monitoring", href: "/shifts/monitoring", icon: Eye },
          { label: "Time Tracking", href: "/shifts/time-tracking", icon: Timer },
          { label: "Attendance", href: "/shifts/attendance", icon: TickCircle }
        ]
      }
    ]
  },
  {
    section: "Financial Management",
    items: [
      {
        label: "Financial",
        icon: MoneyRecive,
        children: [
          // { label: "Invoices", href: "/financial/invoices", icon: DocumentText, feature: "billingModule" },
          { label: "Invoice Logs", href: "/financial/invoice-logs", icon: DocumentText, feature: "billingModule" },
          { label: "Payroll Logs", href: "/financial/payroll-records", icon: DocumentText, feature: "payrollIntegration" },
          // { label: "Create Invoice", href: "/financial/create-invoice", icon: AddCircle, feature: "billingModule" },
          { label: "Patient Accounts", href: "/financial/patient-account-management", icon: Wallet, feature: "billingModule" },
          { label: "Payment Tracking", href: "/financial/payment-tracking", icon: CardReceive, feature: "billingModule" },
          { label: "GST Compliance", href: "/financial/gst-compliance", icon: ClipboardText, feature: "billingModule" },
          { label: "Billing Config", href: "/financial/billing", icon: Receipt, feature: "billingModule" },
          { label: "Wage Config", href: "/financial/wage-config", icon: DollarCircle, feature: "payrollIntegration" },
          { label: "Holiday Calendar", href: "/financial/holidays", icon: CalendarEdit, feature: "payrollIntegration" },
          // { label: "Payroll", href: "/financial/payroll", icon: Wallet, feature: "payrollIntegration" },
          { label: "Payslips", href: "/financial/payslips", icon: DocumentCopy, feature: "payrollIntegration" },
          { label: "Subscription", href: "/financial/subscription", icon: MoneyChange }
        ]
      }
    ]
  },
  {
    section: "System",
    items: [
      {
        label: "User Management",
        icon: Setting2,
        href: "/users/management"
      }
    ]
  }
];
